import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/auth.php';

const AuthUserContext = createContext(null);

export function AuthUserProvider({ children }) {
  const [usuario,  setUsuario]  = useState(null);
  const [loading,  setLoading]  = useState(true); // verificando sesión inicial
  const [token,    setToken]    = useState(() => localStorage.getItem('com_token'));

  /* ── Fetch perfil con token ── */
  const fetchPerfil = useCallback(async (tkn) => {
    if (!tkn) { setLoading(false); return; }
    try {
      const r = await fetch(`${API}?action=perfil`, {
        headers: { 'Authorization': `Bearer ${tkn}` }
      });
      const j = await r.json();
      if (j.success) {
        setUsuario(j.data);
      } else {
        // Token inválido
        localStorage.removeItem('com_token');
        setToken(null);
        setUsuario(null);
      }
    } catch(e) {
      // Error de red — mantener sesión local
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchPerfil(token); }, [token, fetchPerfil]);

  /* ── Login ── */
  const login = async (email, password) => {
    const r = await fetch(`${API}?action=login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    const j = await r.json();
    if (!j.success) throw new Error(j.message);
    localStorage.setItem('com_token', j.data.token);
    setToken(j.data.token);
    setUsuario(j.data.usuario);
    return j.data;
  };

  /* ── Registro ── */
  const registro = async (datos) => {
    const r = await fetch(`${API}?action=registro`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(datos),
    });
    const j = await r.json();
    if (!j.success) throw new Error(j.message);
    localStorage.setItem('com_token', j.data.token);
    setToken(j.data.token);
    setUsuario(j.data.usuario);
    return j.data;
  };

  /* ── Logout ── */
  const logout = async () => {
    try {
      await fetch(`${API}?action=logout`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
      });
    } catch(e) {}
    localStorage.removeItem('com_token');
    setToken(null);
    setUsuario(null);
  };

  /* ── Actualizar usuario local ── */
  const actualizarUsuario = (datos) => setUsuario(u => ({...u, ...datos}));

  /* ── Helper header ── */
  const authHeader = () => ({ 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' });

  return (
    <AuthUserContext.Provider value={{
      usuario, token, loading,
      login, registro, logout,
      actualizarUsuario, authHeader,
      estaLogueado: !!usuario,
    }}>
      {children}
    </AuthUserContext.Provider>
  );
}

export const useAuthUser = () => useContext(AuthUserContext);